import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
  },
  assetsPageModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  closeFullScreen: {
    position: "absolute",
    top: "10px",
    right: "20px",
    cursor: "pointer",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    height: "30px",
    width: "30px",
  },
  floatingDiv: {
    position: "fixed",
    right: "0px",
    width: "550px",
    borderLeft: "2px solid #606479",
    backgroundColor: theme.palette.primary.main,
    overflowX: "hidden",
    overflowY: "scroll",
    zIndex: "100",
  },
}));

export default useStyles;
